
import { useState, useEffect } from 'react';
import {  Table, Row, Col, Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { getLogs } from '../../services/Items/Inventory';
import { useNavigate } from 'react-router-dom';

function ItemLogsModal({ show, handleClose, id, handleBack }) {
   const navigate = useNavigate();
   const [data, setData] = useState([]);
    
   const handleEdit = () => {
    navigate(`/editItem/${id}`);
   }
    useEffect(() => {
        if(id)
        {
            getLogs(id).then(list => {
                console.log(list)
                setData(list);
            })
        }
    },[id])
  return (
    <Modal size="lg" show={show} onHide={handleClose} backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Historial de movimientos</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      {
        (data && data.length !== 0) ? 
        data.map((item, index) => (
            <Row key={index}>
                <Col xl={12}>
                <Table className='mb-5 mt-3'  bordered hover responsive>
                        <thead>
                        <tr className='table-dark'>
                                <th className='text-center'>
                                    Quien realizo el movimiento:
                                    <br></br>
                                    {item.iUsers.userName}
                                </th>
                                <th className='text-center'>
                                    Cuando se realizó el movimiento:
                                    <br></br>
                                    {item.createdAtFormatted}
                                </th>  
                                <th className='text-center'>
                               
                                </th>                               
                            </tr>
                            <tr className='table-secondary'>
                                <th className='text-center'>
                                    Campo     
                                </th>
                                <th className='text-center'>
                                    Valor viejo
                                </th>  
                                <th className='text-center'>
                                    Valor nuevo
                                </th>                               
                            </tr>
                        </thead>
                        <tbody>  
                        {
                            item.ilFields.map((subItem, index) => (
                                    <tr >
                                        <td className='bg-light text-center'>
                                            {subItem.fieldName}
                                        </td>
                                        <td className='text-center'>
                                            {subItem.oldValue}
                                        </td>   
                                        <td className='text-center'>
                                            {subItem.newValue}
                                        </td>                                 
                                    </tr>
                            ))
                        }
                        </tbody>
                    </Table>
                </Col>
            </Row>
            ))
        :
        <h6>No hay movimientos</h6>
        }
    
      
      </Modal.Body>
      <Modal.Footer>
      <Button variant="secondary" onClick={handleBack}>
          Regresar
        </Button>
        <Button variant="secondary" onClick={handleClose}>
          Cerrar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default ItemLogsModal;
